/* @flow */

import moment from 'moment';

function pasteDateValidator(value: moment, options: {message: ?string}, key: string, attributes: any) {
  // format value as moment
  let dateValue = value;
  if (dateValue === undefined || dateValue === null || dateValue === '') {
    // let the presence constraint report the mandatory-field message
    return undefined;
  } else if (typeof dateValue === 'string') {
    dateValue = moment(value);
  }

  // make sure message has been provided
  if (options.message === undefined || options.message === null) {
    throw new Error('Message is needed');
  }

  // check if the date is in the past
  const now = dateValue.utc().startOf('day');
  const today = moment().utc().endOf('day');
  if (now.isAfter(today)) {
    return options.message;
  }

  // success
  return undefined;
}

export default pasteDateValidator;
